module.exports = __webpack_public_path__ + "static/media/spid-logo-animation-black~ZYbHBrkh.3fe355c4.svg";